<template>
    <div>
        <div class="hero fade-in-2s">
            <!-- <div class="custom-topbar-gradient"></div> -->
            <div class="hero-body kenburns-top">
              <div class="languageSelectContainer fade-in-3s">
                <div class="languageForm" :class="{'active': expandLanguageSelector}" @click.stop="handleLanguageSelector(), handleClose('expandLanguageSelector', 'expanded')">
                   <div class="selectedLanguage">
                    <icon class="small-svg flag-container" :name="selectedLanguage.flag" :flag="true"></icon>
                    <span>{{selectedLanguage.language}}</span>
                   </div>
                   <ul class="language-list">
                     <li class="language" v-for="(language, index) in languageSelector" :key="index" @click.stop="selectNewLanguage(language)">
                        <icon class="small-svg flag-container" :name="language.flag" :flag="true"></icon>
                        <span>{{language.language}}</span>
                     </li>
                   </ul>
                </div>
              </div>
              <div class="newsletterContainer fade-in-3s">
                <div class="newsletterForm" :class="{'active': expandNewsletter, 'sent': sentNewsletter, 'error': newsLetterFailure}" @click.stop="handleNewsletter(), handleClose('expandNewsletter', 'expanded')">

                  <!-- Spinner -->
                  <div v-if="startSpinning" class="sdg-newsletter-spinner">
                    <div class="flex-align-center">
                      <icon class="save-spinner-small-svg sdg-spinner flex" name="sdg-wheel"></icon>
                    </div>
                  </div>

                  <icon v-if="showCheckmark" class="tiny-svg fill-white flex-center" style="margin-left: 10px;" name="checkmark"></icon>
                  <span>{{emailSpanText}}</span>

                  <form v-on:submit.prevent="signUpForMailingList(emailInput)">
                    <div class="inputNewsletter">
                      <span class="newsletterFailureText" v-if="newsLetterFailure">{{emailFailureText}}</span>
                      <input id="emailInput" v-else :placeholder="$t('landing.newsletterPlaceHolder')" v-model="emailInput" v-on:input="validateEmail($event.target.value)" ref="emailInput"/>
                    </div>
                    <div class="buttonNewsletter">
                      <button @click.stop="signUpForMailingList(emailInput)" :class="{'error': newsLetterFailure}" type="button" :disabled="!validEmail">{{emailButtonText}}</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
        </div>
        <div class="sdg-wheel-start fade-in-1s">
            <div class="columns">
                <div class="column is-5 is-offset-2 flex-direction-column">
                    <div class="sdg-title">
                        <!-- <h1>{{$t('landing.title')}}</h1> -->
                        <icon class="hero-svg" name="logo"></icon>
                    </div>
                    <div class="sdg-subtitle">
                        <span>{{$t('landing.subtitle')}}</span>
                    </div>
                </div>
                <div class="column sdg-wheel-container">
                    <div class="landing-sdg-wheel-circle">
                        <wheel v-show="currentState === 'landing'" ref="landingWheel" :name="'landing'"></wheel>
                        <div :class="[currentState === 'landing' ? 'scale-in-center-s1' : 'scale-out-center']" class="start-button-wrapper flex-center">
                            <button @click="goToProject()" class="start-button">
                                {{$t('landing.startButtonLabel')}}
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="columns is-centered is-mobile sdg-features fade-in-bottom-2" v-clickoutside="handleClose" @click="handleClose('box')">

            <!-- About -->
            <div class="column is-12-mobile is-2-desktop sdg-features-point sdg-about" :class="{'expand': expandAbout}" @click.stop="handleClose('expandAbout', 'small')">
                <div class="sdg-features-circle flex-direction-column">
                    <icon class="large-svg fill-gray" name="info"></icon>
                </div>
                <div class="sdg-features-button"  style="width: 100%; height: 20px; margin: 5px;">
                    <div class="img-icon img-icon-large about-promo"></div>
                </div>
                <div class="sdg-features-text-container sdg-about flex-center" ref="expandAbout" :class="{'expand': expandAbout}" @click.stop="handleClose('expandAbout', 'expanded')">
                  <div class="relative-div flex-center">
                    <button class="sdg-features-close is-large" @click.stop="expandAbout = false" v-if="expandAbout" aria-label="close"></button>
                    <icon v-if="!expandAbout" class="tiny-svg fill-subtle-white fullscreen-icon" name="enlarge"></icon>
                    <div v-if="!expandAbout" class="sdg-features-text2" v-html="$t('landing.sdgFeatureAboutIntro')"></div>
                    <div v-else class="sdg-features-text fade-in" v-html="$t('landing.sdgFeatureAboutText')"></div>
                  </div>
                </div>
            </div>

            <!-- Global Goal -->
            <div class="column is-12-mobile is-2-desktop sdg-features-point world-goal" :class="{'expand': expandWorldGoal}" @click.stop="handleClose('expandWorldGoal', 'small')">
                <div class="sdg-features-circle">
                    <div class="img-icon img-icon-large world-goal-promo"></div>
                </div>
                <div class="sdg-features-button">
                    <h4 class="sdg-features-header">{{$t('landing.sdgFeatureGlobalGoal')}}</h4>
                </div>
                <div class="sdg-features-text-container world-goal flex-center" ref="expandWorldGoal" :class="{'expand': expandWorldGoal}" @click.stop="handleClose('expandWorldGoal', 'expanded')">
                  <div class="relative-div flex-center">
                    <button class="sdg-features-close is-large" @click.stop="expandWorldGoal = false" v-if="expandWorldGoal" aria-label="close"></button>
                    <icon v-if="!expandWorldGoal" class="tiny-svg fill-subtle-white fullscreen-icon" name="enlarge"></icon>
                    <div v-if="!expandWorldGoal" class="sdg-features-text2" v-html="$t('landing.sdgFeatureGlobalGoalIntro')"></div>
                    <div v-else class="sdg-features-text fade-in" v-html="$t('landing.sdgFeatureGlobalGoalText')"></div>
                  </div>
                </div>
            </div>

            <!-- Action -->
            <div class="column is-12-mobile is-2-desktop sdg-features-point action-heart" :class="{'expand': expandAction}" @click.stop="handleClose('expandAction', 'small')">
                <div class="sdg-features-circle">
                    <div class="img-icon img-icon-large actions-promo"></div>
                </div>
                <div class="sdg-features-button">
                    <h4 class="sdg-features-header">{{$t('landing.sdgFeatureActions')}}</h4>
                </div>
                <div class="sdg-features-text-container action-heart flex-center" ref="expandAction" :class="{'expand': expandAction}" @click.stop="handleClose('expandAction', 'expanded')">
                  <div class="relative-div flex-center">
                    <button class="sdg-features-close is-large" @click.stop="expandAction = false" v-if="expandAction" aria-label="close"></button>
                    <icon v-if="!expandAction" class="tiny-svg fill-subtle-white fullscreen-icon" name="enlarge"></icon>
                    <div v-if="!expandAction" class="sdg-features-text2" v-html="$t('landing.sdgFeatureActionsIntro')"></div>
                    <div v-else class="sdg-features-text fade-in" v-html="$t('landing.sdgFeatureActionsText')"></div>
                  </div>
                </div>
            </div>

            <!-- Results -->
            <div class="column is-12-mobile is-2-desktop sdg-features-point results" :class="{'expand': expandResult}" @click.stop="handleClose('expandResult', 'small')">
                <div class="sdg-features-circle">
                    <div class="img-icon img-icon-large results-promo"></div>
                </div>
                <div class="sdg-features-button">
                    <h4 class="sdg-features-header">{{$t('landing.sdgFeatureResults')}}</h4>
                </div>
                <div class="sdg-features-text-container results flex-center" ref="expandResult" :class="{'expand': expandResult}" @click.stop="handleClose('expandResult', 'expanded')">
                  <div class="relative-div flex-center">
                    <button class="sdg-features-close is-large" @click.stop="expandResult = false" v-if="expandResult" aria-label="close"></button>
                    <icon v-if="!expandResult" class="tiny-svg fill-subtle-white fullscreen-icon" name="enlarge"></icon>
                    <div v-html="$t('landing.sdgFeatureResultsIntro')" v-if="!expandResult" class="sdg-features-text2"></div>
                    <div v-else v-html="$t('landing.sdgFeatureResultsText')" class="sdg-features-text fade-in"></div>
                  </div>
                </div>
            </div>

            <!-- Contact -->
            <div class="column is-12-mobile is-2-desktop sdg-features-point contact" :class="{'expand': expandContact}" @click.stop="handleClose('expandContact', 'small')">
                <div class="sdg-features-circle">
                    <div class="img-icon img-icon-large contact-promo"></div>
                </div>
                <div class="sdg-features-button">
                    <h4 class="sdg-features-header">{{$t('landing.sdgFeatureContact')}}</h4>
                </div>
                <div class="sdg-features-text-container contact flex-center" ref="expandContact" :class="{'expand': expandContact}" @click.stop="handleClose('expandContact', 'expanded')">
                  <div class="relative-div flex-center">
                    <button class="sdg-features-close is-large" @click.stop="expandContact = false" v-if="expandContact" aria-label="close"></button>
                    <icon v-if="!expandContact" class="tiny-svg fill-subtle-white fullscreen-icon" name="enlarge"></icon>
                    <div v-if="!expandContact" class="sdg-features-text2" v-html="$t('landing.sdgFeatureContactIntro')"></div>
                    <div v-else>
                      <h5 class="sdg-features-text fade-in" v-html="$t('landing.sdgFeatureContactText')"></h5>
                      <div class="columns">
                        <div class="column fade-in" style="display: flex; flex-direction: column; align-items: center;">
                          <img src="./../../assets/images/CHER.jpg" :alt="$t('landing.sdgFeatureContactFirstConsultantName')" style="max-width: 200px;">
                          <p><b>{{$t("landing.sdgFeatureContactFirstConsultantName")}}</b></p>
                          <p>{{$t("landing.sdgFeatureContactFirstConsultantTitle")}}</p>
                          <p>{{$t("landing.sdgFeatureContactFirstConsultantAddress")}}</p>
                          <p>{{$t("landing.sdgFeatureContactFirstConsultantPhone")}}</p>
                          <p>{{$t("landing.sdgFeatureContactFirstConsultantMail")}}</p>
                        </div>
                        <div class="column fade-in" style="display: flex; flex-direction: column; align-items: center;">
                          <img src="./../../assets/images/JHKR.jpg" :alt="$t('landing.sdgFeatureContactSecondConsultantName')" style="max-width: 200px;">
                        <p><b>{{$t("landing.sdgFeatureContactSecondConsultantName")}}</b></p>
                          <p>{{$t("landing.sdgFeatureContactSecondConsultantTitle")}}</p>
                          <p>{{$t("landing.sdgFeatureContactSecondConsultantAddress")}}</p>
                          <p>{{$t("landing.sdgFeatureContactSecondConsultantPhone")}}</p>
                          <p>{{$t("landing.sdgFeatureContactSecondConsultantMail")}}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import wheel from './../shared/sdg-wheel/sdg-wheel.vue'
import clickoutside from './../../mixins/shared/clickoutside.js'

export default {
  name: 'landing',
  directives: { clickoutside },
  props: {
    currentState: {
      type: String
    }
  },
  data () {
    return {
      show: true,
      expandAbout: false,
      expandWorldGoal: false,
      expandAction: false,
      expandResult: false,
      expandContact: false,
      expandNewsletter: false,
      expandLanguageSelector: false,
      sentNewsletter: false,
      validEmail: false,
      emailInput: null,
      emailSpanText: this.$t('landing.newsletter'),
      emailButtonText: this.$t('landing.newsletterButtonLabelSignup'),
      emailFailureText: this.$t('landing.newsletterButtonLabelSignupFailure'),
      startSpinning: false,
      showCheckmark: false,
      newsLetterFailure: false,
      languageList: [],
      selectedLanguage: {},
      browserLanguage: '',
      userCachedLanguage: ''
    }
  },
  components: {
    wheel
  },
  computed: {
    ...mapGetters({
      getWheelPositionSet: 'getWheelPositionSet'
    }),
    languageSelector () {
      return this.languageList.filter(language => language.language !== this.selectedLanguage.language)
    }

  },
  methods: {
    ...mapActions({
      setLanguage: 'setLanguage',
      setLandingWheel: 'setLandingWheel',
      setShowProjectModal: 'setShowProjectModal',
      setIconsPath: 'setIconsPath',
      setIconsSelected: 'setIconsSelected',
      setSignUpForMailingList: 'setSignUpForMailingList'
    }),
    goToProject () {
      localStorage.userCachedLanguage = this.selectedLanguage.flag
      // Sets the overall language from the landing page. Can be changed with a project with a language.
      this.setLanguage(this.selectedLanguage.flag)
      this.setShowProjectModal(true)
      this.$emit('goTo', 'project')
    },
    selectNewLanguage (selectedNewLanguage) {
      this.selectedLanguage = selectedNewLanguage
      this.setI18n(selectedNewLanguage.flag)
      localStorage.userCachedLanguage = selectedNewLanguage.flag
      this.handleClose('expandLanguageSelector', 'close')
    },
    handleClose (toOpen, handleClick) {
      if (this[toOpen] && handleClick === 'expanded') {
        // do nothing
      } else {
        this.expandAbout = false
        this.expandWorldGoal = false
        this.expandAction = false
        this.expandResult = false
        this.expandContact = false
        this.expandNewsletter = false
        this.expandLanguageSelector = false
        this.sentNewsletter = false
        this.showCheckmark = false
        this.newsLetterFailure = false
        this.emailSpanText = this.$t('landing.newsletter')
        this.emailButtonText = this.$t('landing.newsletterButtonLabelSignup')
        this.emailFailureText = this.$t('landing.newsletterButtonLabelSignupFailure')
        this.emailInput = ''
        if (handleClick === 'small' || handleClick === 'expanded') {
          if (!this[toOpen]) {
            this[toOpen] = true
            if (toOpen !== 'expandNewsletter' && toOpen !== 'expandLanguageSelector') {
              setTimeout(() => {
                this.$refs[toOpen].scrollTop = 0
              }, 100)
            }
          }
        }
      }
    },
    handleNewsletter () {
      this.expandNewsletter = true
      this.$nextTick(() => {
        this.$refs.emailInput.focus()
      })
    },
    handleLanguageSelector () {
      this.expandLanguageSelector = true
    },
    validateEmail () {
      if (this.emailInput) {
        const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

        if (regex.test(this.emailInput)) {
          this.validEmail = true
        } else {
          this.validEmail = false
        }
      } else {
        this.validEmail = false
      }
    },
    async signUpForMailingList () {
      if (!this.newsLetterFailure && this.validEmail) {
        try {
          this.sentNewsletter = true
          this.startSpinning = true
          this.expandNewsletter = false
          this.emailSpanText = this.$t('landing.newsletterButtonLabelSignupFeedback')

          await this.setSignUpForMailingList(this.emailInput)

          setTimeout(() => {
            this.startSpinning = false
            this.emailSpanText = this.$t('landing.newsletterButtonLabelSignupSucces')
            this.showCheckmark = true
          }, 2000)
        } catch (err) {
          setTimeout(() => {
            this.startSpinning = false
            this.sentNewsletter = false
            this.expandNewsletter = true
            this.newsLetterFailure = true
            this.emailButtonText = this.$t('landing.newsletterButtonLabelSignupFailureButton')

            if (Number(err.message) === 50001) {
              this.emailFailureText = this.$t('landing.newsletterButtonLabelSignupFailureExistingUser')
            }
          }, 2000)
        }
      } else {
        this.newsLetterFailure = false
        this.emailButtonText = this.$t('landing.newsletterButtonLabelSignup')
        this.$nextTick(() => {
          this.$refs.emailInput.focus()
        })
      }
    },
    setI18n (locale) {
      this.$i18n.locale = locale
    }
  },
  mounted () {
    // Move to language selection also
    // this.setGoalList()
    this.setIconsPath()
    this.setIconsSelected(true)
  },
  created () {
    this.browserLanguage = navigator.language
    if (localStorage.userCachedLanguage) {
      this.userCachedLanguage = localStorage.userCachedLanguage
    }
    let danish = {
      language: 'Dansk',
      flag: 'da'
    }
    let english = {
      language: 'English',
      flag: 'en'
    }
    let french = {
      language: 'Français',
      flag: 'fr'
    }
    this.languageList.push(danish, english, french)
    if (this.userCachedLanguage) {
      switch (this.userCachedLanguage) {
        case 'da':
          this.selectedLanguage = danish
          break
        case 'fr':
          this.selectedLanguage = french
          break
        default:
          this.selectedLanguage = english
          break
      }
      this.setI18n(this.userCachedLanguage)
      this.emailSpanText = this.$t('landing.newsletter')
      this.emailButtonText = this.$t('landing.newsletterButtonLabelSignup')
      this.emailFailureText = this.$t('landing.newsletterButtonLabelSignupFailure')
    } else if (this.browserLanguage) {
      switch (this.browserLanguage) {
        case 'da':
          this.selectedLanguage = danish
          break
        case 'fr':
          this.selectedLanguage = french
          break
        default:
          this.selectedLanguage = english
          break
      }
      this.setI18n(this.browserLanguage)
      this.emailSpanText = this.$t('landing.newsletter')
      this.emailButtonText = this.$t('landing.newsletterButtonLabelSignup')
      this.emailFailureText = this.$t('landing.newsletterButtonLabelSignupFailure')
    }
  }
}
</script>
